import { dbAdd, dbDelete, dbGetAll, dbGetById, dbPut } from '../indexedDb.ts';

export interface LocalCategory { 
  id: number; 
  name: string; 
  description?: string;
  type: 'income'|'expense'; 
  icon: string; 
  icon_color?: string; 
  is_default?: boolean;
  created_at: string; 
  updated_at?: string;
  // Sync fields
  server_id?: number;
  last_synced_at?: string;
  needs_sync?: boolean;
}

export function listCategories() { return dbGetAll<LocalCategory>('categories'); }

export function getCategoryById(id: number) {
  return dbGetById<LocalCategory>('categories', id);
}

export async function createCategory(data: Omit<LocalCategory,'id'|'created_at'|'updated_at'|'server_id'|'last_synced_at'|'needs_sync'>) {
  const now = new Date().toISOString();
  return dbAdd('categories', { ...data, created_at: now, needs_sync: true } as any);
}

export async function updateCategory(id: number, data: Partial<LocalCategory>) {
  const current = await dbGetById<LocalCategory>('categories', id);
  if (!current) throw new Error('Category not found');
  const updated = {
    ...current,
    ...data,
    id,
    updated_at: data.updated_at ?? new Date().toISOString(),
    needs_sync: data.needs_sync ?? true
  };
  await dbPut('categories', updated);
  return updated;
}

export function removeCategory(id: number) { return dbDelete('categories', id); }

export async function getCategoriesNeedingSync(): Promise<LocalCategory[]> {
  const all = await dbGetAll<LocalCategory>('categories');
  return all.filter(c => c.needs_sync === true);
}

export async function markSynced(id: number, serverId: number) {
  const current = await dbGetById<LocalCategory>('categories', id);
  if (!current) throw new Error('Category not found');
  current.server_id = serverId;
  current.last_synced_at = new Date().toISOString();
  current.needs_sync = false;
  await dbPut('categories', current);
  return current;
}


